export interface IStorageProvider {}
